import { appApi } from "@src/integrations/redux/app-api";
import { HTTP_METHODS } from "@src/utils/network-constants";

import {
  urlForRideShareSummary,
  urlForRecentRides,
} from "../ride-share-api-urls";

import type {
  GetRideSummaryResponse,
  GetRecentRidesArgs,
  GetRecentRidesResponse,
} from "../ride-share-dtos";

export const rideShareApi = appApi.injectEndpoints({
  endpoints: (builder) => ({
    getRideSummary: builder.query<GetRideSummaryResponse, { spaceId: string }>({
      query: ({ spaceId }) => ({
        url: urlForRideShareSummary(spaceId),
        method: HTTP_METHODS.GET,
      }),
    }),
    getRecentRides: builder.query<GetRecentRidesResponse, GetRecentRidesArgs>({
      query: ({ spaceId, limit, startDate, endDate }) => ({
        url: urlForRecentRides(spaceId, { limit, startDate, endDate }),
        method: HTTP_METHODS.GET,
      }),
    }),
  }),
  overrideExisting: "throw",
});

export const {
  useGetRideSummaryQuery,
  useGetRecentRidesQuery,
} = rideShareApi;